/**
 * Ensures a phone number always starts with a "+" sign
 * @param phone - The phone number to format
 * @returns The phone number with "+" prefix
 */
export const ensurePhonePrefix = (phone?: string): string => {
  if (!phone || typeof phone !== "string") {
    return "+";
  }

  if (phone[0] !== "+") {
    return `+${phone}`;
  }

  return phone;
};

/**
 * Handles phone number input change to ensure "+" prefix
 * @param value - The input value from the change event
 * @returns The formatted phone number
 */
export const handlePhoneChange = (value: string): string => {
  if (value.length === 0) {
    return "+";
  }

  // Make sure phone number starts with +
  if (value[0] !== "+") {
    return `+${value}`;
  }

  return value;
};
